var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "mb-34 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-img', {
    staticClass: "w-100 main-img mx-auto",
    attrs: {
      "src": '/images/sub/product/' + _vm.file + '/main_img.jpg',
      "max-width": "486"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "pl-md-20 pl-lg-60 pt-md-30 pt-xl-90 word-keep-all"
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit tit--lg",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.tit))])]), _c('div', {
    staticClass: "prduct-detail mb-30 mb-lg-60 pa-20 pa-md-30 py-lg-36 px-md-54 px-lg-84"
  }, [_c('p', {
    staticClass: " page-text"
  }, [_vm._t("default")], 2)]), _c('v-row', {
    staticClass: "row--small row-cols-5"
  }, [_c('v-col', {
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": '/images/sub/product/' + _vm.file + '/1.jpg'
    }
  })], 1), _c('v-col', {
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": '/images/sub/product/' + _vm.file + '/2.jpg'
    }
  })], 1), _c('v-col', {
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "200"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": '/images/sub/product/' + _vm.file + '/3.jpg'
    }
  })], 1), _c('v-col', {
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "300"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": '/images/sub/product/' + _vm.file + '/4.jpg'
    }
  })], 1), _c('v-col', {
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "400"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": '/images/sub/product/' + _vm.file + '/5.jpg'
    }
  })], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }